export interface LinkDeliveryChoice {
    sendViaEmail: boolean;
    sendViaSms: boolean;
}

export interface CustomerLinkContacts {
    /** Trimmed; undefined when absent or blank. */
    email?: string;
    /** Trimmed `mobile_phone` only: the landline `phone` is never a text target. */
    mobile?: string;
}

export const NO_LINK_DELIVERY: LinkDeliveryChoice = { sendViaEmail: false, sendViaSms: false };
